<div *ngIf="initialized && length && numberOfPages >= 1" class="flex flex-row justify-between items-center h-100-percent paginator user-select-none">
  <div class="flex flex-row justify-center items-center mat-subtitle-2 mb-0 fw-500">
    {{ 'PAGINATOR.ITEMS_PER_PAGE' | transloco }}
    <div class="paginator-form-field ml-12">
      <select [(ngModel)]="pageSize" (change)="pageSizeChanged()">
        <option *ngFor="let pageSizeOption of pageSizeOptions" [ngValue]="pageSizeOption">{{ pageSizeOption }}</option>
      </select>
    </div>
  </div>
  <div class="flex flex-row justify-center items-center">
    <div class="fs-14 pr-24 fw-400 mat-subtitle-2 mb-0">{{pageIndex * pageSize + 1}} - {{(pageIndex * pageSize + pageSize) > length ? length : (pageIndex * pageSize + pageSize)}} of {{length}}</div>
    <mat-icon svgIcon="first_page" class="icon-lg" [ngClass]="{'disabled' : pageIndex === 0}" (click)="pageIndex !== 0 && goToPage(0)"></mat-icon>
    <mat-icon svgIcon="chevron_left" class="icon-lg" [ngClass]="{'disabled' : pageIndex === 0}" (click)="pageIndex !== 0 && goToPage(pageIndex - 1)"></mat-icon>

    <ng-container *ngIf="range[0] !== 0">
      <div class="page-number-delimiter">...</div>
    </ng-container>

    <div *ngFor="let page of range" class="flex items-center justify-center page-number mat-subtitle-2 mb-0 fw-500 fs-16 pt-8 pb-8 ml-4 mr-4"
      [ngClass]="{'active' : pageIndex === page}" (click)="goToPage(page)">{{ page + 1 }}</div>

    <ng-container *ngIf="range[range.length - 1] !== numberOfPages - 1">
      <div class="page-number-delimiter">...</div>
    </ng-container>

    <mat-icon svgIcon="chevron_right" class="icon-lg" [ngClass]="{'disabled' : pageIndex === numberOfPages - 1}"
      (click)="pageIndex !== numberOfPages - 1 && goToPage(pageIndex + 1)"></mat-icon>
    <mat-icon svgIcon="last_page" class="icon-lg" [ngClass]="{'disabled' : pageIndex === numberOfPages - 1}"
    (click)="pageIndex !== numberOfPages - 1 && goToPage(numberOfPages - 1)"></mat-icon>
  </div>
</div>

